import { render, staticRenderFns } from "./authorizationSwitch.vue?vue&type=template&id=429d5064&"
import script from "./authorizationSwitch.vue?vue&type=script&lang=js&"
export * from "./authorizationSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports